<template>
  <div>
    <div class="popper"></div>
    <div class="message-box__wrapper">
      <div class="message-box">
        <div class="message-box-header">
          <div class="message-box-title">{{title&&title != ''?title:'确认'}}</div>
          <button class="message-box-close" @click="close()">
            <img src="../../../../static/images/c.png"/>
          </button>
        </div>

        <div class="message-box-content">
          <div class="message-box__message">
            <p>{{message}}</p>
          </div>
        </div>

        <div class="message-box__btns">
          <button class="message-box-cancel" @click="cancel()">取消</button>
          <button class="message-box-sure" @click="confirm()">确定</button>
        </div>


      </div>
    </div>
  </div>
</template>

<script type="text/babel">

  export default {
    data() {
      return {
        visible: false,
        onClose: null,
        onCancel: null,
        onConfirm:null,
        zIndex: null,
        title:'',
        message:'',
      };
    },

    computed: {

    },

    watch: {

    },

    methods: {

      close() {
        this.visible = false;
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
        if (typeof this.onClose === 'function') {
          this.onClose();
        }
      },
      cancel(){
        this.visible = false;
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
        if (typeof this.onCancel === 'function') {
          this.onCancel();
        }
      },
      confirm(){
        this.visible = false;
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
        if (typeof this.onConfirm === 'function') {
          this.onConfirm();
        }
      },

    },
    mounted() {

    },
    beforeDestroy() {

    }
  };

</script>


<style scoped>
  .popper{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 6147483640;
  }
  .message-box__wrapper{
    position: absolute;
    top: 200px;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 6147483647;
  }
  .message-box{
    display: inline-block;
    width: 350px;
    padding-bottom: 10px;
    vertical-align: middle;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    font-size: 18px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    text-align: left;
    overflow: hidden;
    backface-visibility: hidden;
  }
  .message-box-header{
    position: relative;
    padding: 15px;
    padding-bottom: 10px;
  }
  .message-box-title{
    padding-left: 0;
    margin-bottom: 0;
    font-size: 18px;
    line-height: 1;
    color: #303133;
  }
  .message-box-close{
    position: absolute;
    top: 15px;
    right: 15px;
    padding: 0;
    border: none;
    outline: none;
    background: transparent;
    font-size: 16px;
    cursor: pointer;
  }
  .message-box-content{
    position: relative;
    padding: 10px 15px;
    color: #606266;
    font-size: 14px;
  }
  .message-box__message p{
    margin: 0;
    line-height: 24px;
  }
  .message-box__btns{
    padding: 5px 15px 0;
    text-align: right;
  }
  .message-box-cancel{
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-color: #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: .1s;
    font-weight: 500;
  }
  .message-box-sure{
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    color: #fff;
    background-color: #7cd1e6;
    border:1px solid #7cd1e6;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    display: inline-block;
  }
</style>
